module.exports = __webpack_public_path__ + "static/media/glass-whiskey.6a77d91d.svg";